import { LoggingService } from '@adaptiva/core/logging';
import { HttpEvent, HttpHandlerFn, HttpParams, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

/**
 * @deprecated This is a horrible idea and should be removed
 */
export function httpParamsInterceptor(_req: HttpRequest<any>, _handler: HttpHandlerFn): Observable<HttpEvent<any>> {
	if (_req.params.keys().length)
		return _handler(_modifyRequest(_req));

	return _handler(_req);
}

function _modifyRequest(_request: HttpRequest<any>): HttpRequest<any> {
	let _params: HttpParams = new HttpParams();
	const _logger: LoggingService = inject(LoggingService);
	const _modifiedUrl: string = _request.params.keys()
		.reduce((_url: string, _key: string) => {
			const _value: string = _request.params.get(_key);
			const _isExisting: boolean = _url.indexOf(_key) !== -1;

			// Enforce a value to replace starts with :
			// Some urls happen to have a url parameter that also exists as part of the full url excluding any url encoded parameters.
			// This means that whoever is setting up these endpoints in this codebase would need to pass those through as HttpParams as well or we just enforce
			// url parameters to replace in the url start with :. The latter seems like the simpler option.
			if (_isExisting && _key[0] !== ':') {
				_params = _params.set(_key, _value);

				return _url;
			}

			// Ideally, we would delete the key here from request.params and reassign but this fails after deleting more than a single key. Because of this gotcha, we instead add
			// values into a new HttpParams object that don't get touched then pass those on to the final returned HttpRequest.
			// This block would be a good place to add logging if we want to do that.
			if (_isExisting)
				return _url.replace(_key, _value);
			else
				_params = _params.set(_key, _value);

			return _url;
		}, _request.url);

	// If the url has changed then one ore more properties in the original params object would have been deleted. Return the new url and params object.
	if (_modifiedUrl !== _request.url) {
		_logger.debug('httpParamsInterceptor', `Deprecated param replacement triggered for ${_request.url}`)();

		return _request.clone({ url: _modifiedUrl, params: _params });
	}

	return _request;
}
